import axios, { AxiosInstance } from "axios";
import { successResponseInterceptor, errorResponseInterceptor } from "../infrastructure/global";

class ApiClient {
    instance: AxiosInstance;
    
    //private constructor() { } tsc!!!
    constructor() {
        this.instance = axios.create({
            baseURL: '/d2c',
            method: 'post'
        });

        this.instance.interceptors.response.use(
            successResponseInterceptor,
            errorResponseInterceptor
        );
    }
}

export const apiClient = new ApiClient();